// extracted by mini-css-extract-plugin
module.exports =  {"ResendConfirmation":"Nt4PZiQ_pMswoPh5sOcQ"};